/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateCompanyDto
 */
export interface CreateUpdateCompanyDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCompanyDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCompanyDto
     */
    officialName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCompanyDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCompanyDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCompanyDto
     */
    taxIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCompanyDto
     */
    taxCountryCodeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCompanyDto
     */
    taxCountryCodeShortname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCompanyDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCompanyDto
     */
    emailInvoices?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCompanyDto
     */
    externalReferral?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCompanyDto
     */
    branchId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateCompanyDto
     */
    batteries?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCompanyDto
     */
    healthcareFacilityId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCompanyDto
     */
    monthlySettlement?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCompanyDto
     */
    invoicesSettlement?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCompanyDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCompanyDto
     */
    blockedForPrint?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCompanyDto
     */
    autoInvoice?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCompanyDto
     */
    autoApproveInvoice?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateCompanyDto
     */
    invoicePaymentDays?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCompanyDto
     */
    invoiceIncludeExaminedNames?: boolean | null;
}

/**
 * Check if a given object implements the CreateUpdateCompanyDto interface.
 */
export function instanceOfCreateUpdateCompanyDto(value: object): value is CreateUpdateCompanyDto {
    return true;
}

export function CreateUpdateCompanyDtoFromJSON(json: any): CreateUpdateCompanyDto {
    return CreateUpdateCompanyDtoFromJSONTyped(json, false);
}

export function CreateUpdateCompanyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateCompanyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'officialName': json['officialName'] == null ? undefined : json['officialName'],
        'address': json['address'] == null ? undefined : json['address'],
        'nip': json['nip'] == null ? undefined : json['nip'],
        'taxIdentifier': json['taxIdentifier'] == null ? undefined : json['taxIdentifier'],
        'taxCountryCodeId': json['taxCountryCodeId'] == null ? undefined : json['taxCountryCodeId'],
        'taxCountryCodeShortname': json['taxCountryCodeShortname'] == null ? undefined : json['taxCountryCodeShortname'],
        'email': json['email'] == null ? undefined : json['email'],
        'emailInvoices': json['emailInvoices'] == null ? undefined : json['emailInvoices'],
        'externalReferral': json['externalReferral'] == null ? undefined : json['externalReferral'],
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'batteries': json['batteries'] == null ? undefined : json['batteries'],
        'healthcareFacilityId': json['healthcareFacilityId'] == null ? undefined : json['healthcareFacilityId'],
        'monthlySettlement': json['monthlySettlement'] == null ? undefined : json['monthlySettlement'],
        'invoicesSettlement': json['invoicesSettlement'] == null ? undefined : json['invoicesSettlement'],
        'active': json['active'] == null ? undefined : json['active'],
        'blockedForPrint': json['blockedForPrint'] == null ? undefined : json['blockedForPrint'],
        'autoInvoice': json['autoInvoice'] == null ? undefined : json['autoInvoice'],
        'autoApproveInvoice': json['autoApproveInvoice'] == null ? undefined : json['autoApproveInvoice'],
        'invoicePaymentDays': json['invoicePaymentDays'] == null ? undefined : json['invoicePaymentDays'],
        'invoiceIncludeExaminedNames': json['invoiceIncludeExaminedNames'] == null ? undefined : json['invoiceIncludeExaminedNames'],
    };
}

export function CreateUpdateCompanyDtoToJSON(value?: CreateUpdateCompanyDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'officialName': value['officialName'],
        'address': value['address'],
        'nip': value['nip'],
        'taxIdentifier': value['taxIdentifier'],
        'taxCountryCodeId': value['taxCountryCodeId'],
        'taxCountryCodeShortname': value['taxCountryCodeShortname'],
        'email': value['email'],
        'emailInvoices': value['emailInvoices'],
        'externalReferral': value['externalReferral'],
        'branchId': value['branchId'],
        'batteries': value['batteries'],
        'healthcareFacilityId': value['healthcareFacilityId'],
        'monthlySettlement': value['monthlySettlement'],
        'invoicesSettlement': value['invoicesSettlement'],
        'active': value['active'],
        'blockedForPrint': value['blockedForPrint'],
        'autoInvoice': value['autoInvoice'],
        'autoApproveInvoice': value['autoApproveInvoice'],
        'invoicePaymentDays': value['invoicePaymentDays'],
        'invoiceIncludeExaminedNames': value['invoiceIncludeExaminedNames'],
    };
}

